import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { createAuthSlice } from '../modules/auth/store/authSlice';
import { AuthStore } from '../modules/auth/store/types';
import { createMessagesSlice } from '../modules/chat2/store/messagesSlice';
import { ChatStore } from '../modules/chat2/store/types';
import { createProjectSlice } from '../modules/projects/store/projectSlice';
import { ProjectStore } from '../modules/projects/store/types';
import { WorkspaceStore } from '../modules/workspace/store/types';
import { createWorkspaceSlice } from '../modules/workspace/store/workspaceSlice';

type Store = ChatStore & WorkspaceStore & AuthStore & ProjectStore;

export const useStore = create<Store>()(
  devtools((...a) => ({
    ...createMessagesSlice(...a),
    ...createWorkspaceSlice(...a),
    ...createAuthSlice(...a),
    ...createProjectSlice(...a),
  }))
);
